module.exports = __webpack_public_path__ + "48c54672.svg";